<template>
  <div class="layout-view">
    <div
      class="layout-header center-content"
      :class="{ 'layout-header-black': isMy }"
    >
      <div class="header-content">
        <router-link
          :to="{ name: 'Homepage' }"
          class="header-logo"
        ></router-link>
        <div class="header-nav">
          <div
            v-for="(nav, index) in navList"
            :key="nav.routeName"
            class="nav-item"
            :class="{ active: index == active }"
            @click="jump(nav)"
          >
            {{ nav.title }}
            <div class="nav-sub" v-if="nav.subList" v-show="index == 1">
              <div
                class="nab-sub-item"
                v-for="sub in nav.subList"
                :key="sub.routeName"
                @click.stop="jumpSub(sub)"
              >
                {{ sub.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="header-global">
          <div class="lang-icon"></div>
          <span class="lang-text">CN</span>
          <div class="lang-arrow"></div>
        </div>
        <div class="header-operate" v-if="has_register">
          <div class="login-btn" @click="goMy">
            <img src="../assets/image/user.png" class="header-avatar" />
            我的
          </div>
        </div>
        <div class="header-operate" v-else>
          <div class="login-btn" @click="register">登陆</div>
          <div class="login-btn" @click="register">注册</div>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <router-view />
    </div>
    <LayoutFooter :navs="navList.slice(1)" />
    <div class="operate-box">
      <div v-if="showTop" class="operate-item to-top" @click="scrollToTop">
        顶 部
      </div>
      <div class="operate-item" @click="handleService" v-if="false">
        <img
          src="../assets/image/icon/customer_service.png"
          class="customer-service"
        />
      </div>
    </div>
  </div>
  <LoginModal v-model:visible="visible"></LoginModal>
</template>

<script lang="ts" name="LayoutView" setup>
import { computed, ref, unref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import LoginModal from "../components/LoginModal.vue";
import LayoutFooter from "../layout/LayoutFooter.vue";
import { getToken } from "@/common/storage";

interface Nav {
  title: string;
  routeName: string;
  subList?: Nav[];
  link?: string;
}

const navList = ref<Nav[]>([
  { title: "首页", routeName: "Homepage" },
  { title: "申报审批", routeName: "Apply" },
  { title: "办会原则", routeName: "Principle" },
  { title: "全链路解决方案", routeName: "Solution" },
  { title: "“遇”杭州", routeName: "Information" },
  { title: "关于我们", routeName: "Mine" },
]);

const router = useRouter();
const route = useRoute();
const isMy = computed(() => route.name == "My");
const active = computed(() =>
  navList.value.findIndex((n) => n.routeName === route.name)
);
// const blueList = ["Approval", "Apply", "Solution", "Information", "Mine"];
// const is_blue = computed(() => blueList.includes(route.name as string));

const visible = ref<boolean>(false);
const has_register = !!getToken();
const register = () => {
  router.push({ name: "Login", query: { r: location.pathname } });
};
const goMy = () => {
  router.push({ name: "My" });
};

const jump = (nav: Nav) => {
  router.push({ name: nav.routeName });
};
const jumpSub = (sub: Nav) => {
  router.push({ name: sub.routeName, query: { link: sub.link } });
};
watchEffect(() => {
  const name = route.name;
  const index = unref(navList).findIndex((item: Nav) => item.routeName == name);
  if (index > -1) {
    active.value = index;
  }
});
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
const showTop = ref(false);
window.onscroll = function () {
  var currentHeight =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop;
  // 页面滚动超过300px就显示
  if (currentHeight > 600) {
    showTop.value = true;
  } else {
    showTop.value = false;
  }
};

const handleService = () => {
  console.log("handleService");
};
</script>

<style lang="less" scoped>
.layout-header-black {
  .nav-item,
  .lang-text {
    color: var(--black);
  }
  .header-logo {
    background-image: url(../assets/image/home/logo-color.png);
  }
  .lang-icon {
    background-image: url(../assets/image/global-black.png);
  }
  .lang-arrow {
    background-image: url(../assets/image/down-black.png);
  }
  .login-btn {
    &:last-of-type {
      background: #1b69a3;
    }
  }
}
.layout-header {
  position: absolute;
  left: 0;
  right: 0;
  top: 28px;
  padding: 0 160px;
  z-index: 100;
  width: 100%;
  height: 65px;
}
.header-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-logo {
  width: 119px;
  height: 64px;
  background: url(../assets/image/logo.png) center / contain no-repeat;
}
.header-nav {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 10px;
  min-width: 0;
}
.nav-item {
  position: relative;
  margin-left: 90px;
  height: 100%;
  color: var(--white);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 27px;
  cursor: pointer;
  &.active {
    color: var(--main-color);
  }
  &:hover {
    .nav-sub {
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
.nav-sub {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translate(-50%, 0);
  border-radius: 0 0 6px 6px;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(8px);
  padding: 6px;
  &:hover {
    opacity: 1;
    transition: all 0.5s;
  }
  .nab-sub-item {
    height: 28px;
    line-height: 28px;
    padding: 0 8px;
    box-sizing: border-box;
    color: #2d4875;
    white-space: nowrap;
    &:hover {
      color: var(--main-color);
    }
  }
}
.header-global {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.lang-icon {
  width: 20px;
  height: 20px;
  background: url(../assets/image/global.png) center / contain no-repeat;
}
.lang-text {
  color: var(--white);
  font-size: 16px;
  line-height: 24px;
  margin-left: 6px;
}
.lang-arrow {
  margin-left: 2px;
  width: 8px;
  height: 5px;
  background: url(../assets/image/down.png) center / contain no-repeat;
}
.header-operate {
  display: flex;
  align-items: center;
}
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
  width: 115px;
  height: 45px;
  border-radius: 45px;
  border: 1px solid rgba(255, 255, 255, 0.54);
  color: var(--white);
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
  &:last-of-type {
    background: rgba(255, 255, 255, 0.17);
  }
}
.header-avatar {
  margin-right: 9px;
  width: 22px;
  height: 22px;
}
.operate-box {
  position: fixed;
  right: 40px;
  bottom: 60px;
  z-index: 1000;
  .operate-item {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;
    fill: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(2px);
    &:hover {
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
    }
    &:not(:last-of-type) {
      margin-bottom: 24px;
    }
    .customer-service {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
